import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-neutral-950 text-neutral-400 py-16 border-t border-neutral-800">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <Link to="/" className="inline-block mb-6">
              <img 
                src="https://images.leadconnectorhq.com/image/f_webp/q_80/r_300/u_https://assets.cdn.filesafe.space/Zrqvy6cNzSbnzDV55cv1/media/6936d9b74b202f068ab37a46.png" 
                alt="Easy Umzug Logo" 
                width="172"
                height="48"
                loading="lazy"
                decoding="async"
                className="h-12 w-auto brightness-0 invert"
              />
            </Link>
            <p className="mb-4 font-medium">
              Zuverlässiger Umzugsservice und Möbelmontage in Augsburg und Umgebung.
            </p>
            <div className="mb-6 font-medium text-neutral-400 text-sm">
              <p className="text-white">Andriy Savransky</p>
              <p>Erfurter Str. 2 a</p>
              <p>86368 Gersthofen</p>
            </div>
            <div className="flex gap-4">
              <a href="#" aria-label="Facebook" className="w-10 h-10 rounded-full bg-neutral-800 flex items-center justify-center hover:bg-primary hover:text-white transition-colors">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path></svg>
              </a>
              <a href="https://share.google/xw8JE3IKl3tC9Kcw0" aria-label="Google Bewertungen" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-neutral-800 flex items-center justify-center hover:bg-primary hover:text-white transition-colors">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M12.48 10.92v3.28h7.84c-.24 1.84-.853 3.187-1.787 4.133-1.147 1.147-2.933 2.4-6.053 2.4-4.827 0-8.6-3.893-8.6-8.72s3.773-8.72 8.6-8.72c2.6 0 4.507 1.027 5.907 2.347l2.307-2.307C18.747 1.44 16.133 0 12.48 0 5.867 0 .307 5.387.307 12s5.56 12 12.173 12c3.573 0 6.267-1.173 8.373-3.36 2.16-2.16 2.84-5.213 2.84-7.667 0-.76-.053-1.467-.173-2.053H12.48z"/></svg>
              </a>
            </div>
          </div>
          
          <div>
            <h4 className="font-heading text-white text-lg mb-6">Leistungen</h4>
            <ul className="space-y-3 font-medium">
              <li><Link to="/umzugsservice" className="hover:text-primary transition-colors">Umzugsservice</Link></li>
              <li><Link to="/moebelmontage" className="hover:text-primary transition-colors">Möbelmontage</Link></li>
              <li><Link to="/bodenbelag" className="hover:text-primary transition-colors">Bodenbelag (Laminat, Vinyl)</Link></li>
              <li><Link to="/lichtinstallation" className="hover:text-primary transition-colors">Lichtinstallation</Link></li>
              <li><Link to="/pflasterarbeiten" className="hover:text-primary transition-colors">Pflasterarbeiten</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-heading text-white text-lg mb-6">Servicegebiete</h4>
            <ul className="space-y-3 font-medium">
              <li><Link to="/augsburg" className="hover:text-primary transition-colors">Augsburg</Link></li>
              <li><Link to="/ulm" className="hover:text-primary transition-colors">Ulm</Link></li>
              <li><Link to="/guenzburg" className="hover:text-primary transition-colors">Günzburg</Link></li>
              <li><Link to="/landsberg" className="hover:text-primary transition-colors">Landsberg</Link></li>
              <li><Link to="/muenchen" className="hover:text-primary transition-colors">München</Link></li>
              <li><Link to="/ingolstadt" className="hover:text-primary transition-colors">Ingolstadt</Link></li>
              <li><Link to="/donauwoerth" className="hover:text-primary transition-colors">Donauwörth</Link></li>
              <li><Link to="/neuburg-an-der-donau" className="hover:text-primary transition-colors">Neuburg an der Donau</Link></li>
              <li><Link to="/heidenheim-an-der-brenz" className="hover:text-primary transition-colors">Heidenheim an der Brenz</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-heading text-white text-lg mb-6">Geschäftszeiten</h4>
            <ul className="space-y-3 font-medium">
              <li className="flex justify-between"><span>Sonntag:</span> <span>Geschlossen</span></li>
              <li className="flex justify-between"><span>Montag:</span> <span>8:00 - 22:00 Uhr</span></li>
              <li className="flex justify-between"><span>Dienstag:</span> <span>8:00 - 22:00 Uhr</span></li>
              <li className="flex justify-between"><span>Mittwoch:</span> <span>8:00 - 22:00 Uhr</span></li>
              <li className="flex justify-between"><span>Donnerstag:</span> <span>8:00 - 22:00 Uhr</span></li>
              <li className="flex justify-between"><span>Freitag:</span> <span>8:00 - 22:00 Uhr</span></li>
              <li className="flex justify-between"><span>Samstag:</span> <span>8:00 - 22:00 Uhr</span></li>
            </ul>
          </div>
        </div>
        
        <div className="pt-8 border-t border-neutral-800 flex justify-center mb-6">
          <a
            href="https://zappages.de/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1.5 px-4 py-2 rounded-md bg-neutral-900 border border-neutral-700 hover:border-primary transition-colors text-sm"
          >
            <span className="text-neutral-400">Webdesign von</span>
            <span className="text-primary font-heading font-bold tracking-wide">ZapPages</span>
          </a>
        </div>
        
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 font-medium text-sm">
          <p>&copy; {new Date().getFullYear()} Easy Umzug Transport Möbelmontage. Alle Rechte vorbehalten.</p>
          <div className="flex flex-wrap justify-center gap-4 md:gap-6">
            <Link to="/bewertung" className="hover:text-white transition-colors">Bewerte uns</Link>
            <Link to="/kontakt" className="hover:text-white transition-colors">Kontakt</Link>
            <Link to="/ueber-uns" className="hover:text-white transition-colors">Über uns</Link>
            <Link to="/impressum" className="hover:text-white transition-colors">Impressum</Link>
            <Link to="/datenschutz" className="hover:text-white transition-colors">Datenschutz</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;